module.exports = __webpack_public_path__ + "static/media/btt-logo.63c49d74.svg";